<template>
  <div class="">
    <div class="row mt-3">
      <div class="col-sm-6">
        <div >
          <img src="https://wernicke-foto.de/bilder/about/01.jpg" width="100%" alt="">
        </div>
      </div>
      <div class="col-sm-5 pl-5 mt-5">
    
        <h6 class="text-left"><b>HALLO MEIN NAME IST FRANK WERNICKE. ICH BIN FOTOGRAF</b></h6>
        <p class="text-left">
          Fotografie ist für mich eine Kunst der Beobachtung. Es geht darum, etwas Interessantes zu finden, gern an
          einem gewöhnlichen Ort ... Ich habe herausgefunden, dass es wenig mit den Dingen zu tun hat, die man sieht
          sondern mit dem, wie man sie sieht. Das Leben ist wie eine Kamera. In meinem Portfolio gibt es erfolgreiche
          Fotoshootings und viele zufriedenen Kunden. Alle Models, mit denen ich gearbeitet habe, waren mit meinen
          Arbeiten mehr als zufrieden.<router-link class="card-link" :to="'/gallery'"> Schau dir die Galerie an,</router-link>  um mehr über meine Fähigkeiten und Stil zu erfahren.
          Ich biete eine breite Palette von Dienstleistungen an und kann an jedem Ort der Welt Fotos jeglicher Art
          machen. <br>
          Gern arbeite ich auch in meinem kleinen Fotostudio.</p>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <div class="row">
          <div class="col-sm-2"></div><h5 class="col-sm-2 font-weight-bold text-left"><p class="">ERWÄHNENSWERT</p></h5><div class="col-sm-2"></div>
         
          
        </div>
        

        <div class="row ">
          <div class="col-sm-2"></div><div class="col-sm-2 font-weight-bold text-left">1980 – Oktober</div><div class="col-sm-2"></div>
          <div class="col-sm-5 pl-5 text-left"><p>Beginn einer Ausbildung; in dieser Zeit habe ich gelernt selbst meine
            schwarz-weiß-Filme zu entwickeln. Von
            meinem ersten Geld habe ich mir meine erste Kamera gekauft. Es war die legendäre Pentax ME Super mit drei
            tollen Objektiven.</p></div>
        </div>
        <div class="row">
          <div class="col-sm-2"></div><div class="col-sm-2 font-weight-bold text-left">1991 – September</div><div class="col-sm-2"></div>
          <div class="col-sm-5 pl-5 text-left"><p>Studium als Diplom Verwaltungswirt mit anschließender Tätigkeit im IT-Bereich
            aufgrund der Marktlage.</p></div>
        </div>
        <div class="row">
          <div class="col-sm-2"></div><div class="col-sm-2 font-weight-bold text-left">1992 – Mitte</div><div class="col-sm-2"></div>
          <div class="col-sm-5 pl-5 text-left"><p>Einstieg in die Digitalfotografie wegen nicht lieferbarer Bildqualität als
            Tauchlehrer für Unterwasserfotografie</p></div>

        </div>
        <div class="row text-center">
          <div class="col-sm-2"></div><div class="col-sm-2 font-weight-bold text-left">2017 – Ende</div><div class="col-sm-2"></div>
          <div class="col-sm-5 pl-5 text-left"><p>Mit den tollen bezahlbaren professionellen Digitalkameras unter 10 000,- €: Aufleben
            der Obsession Fotografie. Gründung von "Wernicke Fotografie" mit allem was dazu gehört.</p></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "About"
  }
</script>

<style scoped>

</style>